// @ts-nocheck
/**
 * Surpanth Footer Back to Top Controller
 */
function initSurpanthFooter(footer) {
  const backTop = footer.querySelector('[data-surpanth-back-top]');
  if (!backTop) return;

  const toggleBackTop = function () {
    if (window.scrollY > 500) {
      backTop.classList.add('is-visible');
    } else {
      backTop.classList.remove('is-visible');
    }
  };

  window.addEventListener('scroll', toggleBackTop, { passive: true });
  backTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  toggleBackTop();
}

function initAllSurpanthFooters() {
  document.querySelectorAll('.surpanth-footer').forEach(initSurpanthFooter);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSurpanthFooters);
} else {
  initAllSurpanthFooters();
}

